module.exports = __webpack_public_path__ + "static/media/about pajoohyar.3243fa59.png";